import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchAllMatchesFilters, fetchAllProfiles, sendInterest, addShortlistProfile } from "../services/matchService";

// Fetch matches with filters
export const fetchMatches = createAsyncThunk(
  "matches/fetchMatches",
  async (filters, thunkAPI) => {
    try {
      const res = await fetchAllMatchesFilters();
      return res;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to fetch matches");
    }
  }
);

//Get all profiles
export const fetchProfiles = createAsyncThunk(
  "matches/fetchProfiles",
  async (_, thunkAPI) => {
    try {
      const res = await fetchAllProfiles();
      return res;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to fetch profiles");
    }
  }
);

//send interest
export const sendInterestToProfile = createAsyncThunk(
  "matches/sendInterest",
  async (profileId, thunkAPI) => {
    try {
      const res = await sendInterest(profileId);
      return res;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to send interest");
    }
  }
);

//shortlist profile
export const userAddShortlistProfile = createAsyncThunk(
  "matches/shortlistProfile",
  async (profileId, thunkAPI) => {
    try {
      const res = await addShortlistProfile(profileId);
      return res;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to shortlist profile");
    }
  }
);

//block profile
export const blockProfile = createAsyncThunk(
  "matches/blockProfile",
  async (profileId, thunkAPI) => {
    try {
      const res = await blockProfile(profileId);
      return res;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to block profile");
    }
  }
);

const matchSlice = createSlice({
  name: "matches",
  initialState: {
    list: [],
    loading: false,
    error: null,
    filters: {},
  },
  reducers: {
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMatches.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMatches.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchMatches.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }).addCase(fetchProfiles.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchProfiles.fulfilled, (state, action) => {
        state.loading = false;
        state.profiles = action.payload;
      })
      .addCase(fetchProfiles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }).addCase(sendInterestToProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(sendInterestToProfile.fulfilled, (state, action) => {
        state.loading = false;
        // Optionally update the profile's interest status in the state
      })
      .addCase(sendInterestToProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }).addCase(userAddShortlistProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(userAddShortlistProfile.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(userAddShortlistProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }).addCase(blockProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(blockProfile.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(blockProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    }
});

export const { setFilters } = matchSlice.actions;
export default matchSlice.reducer;